import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAqBJFVc-m6vvq7st9mpWegbNtf_hQRv3E",
  authDomain: "song-feng.firebaseapp.com",
  databaseURL: "https://song-feng.firebaseio.com",
  projectId: "song-feng",
  storageBucket: "song-feng.appspot.com",
  messagingSenderId: "33083160716",
  appId: "1:33083160716:web:1aba8d1acabf39bc28e3a9",
  measurementId: "G-PH0Y0GZJEZ"
};
// Get a Firestore instance
firebase.initializeApp(firebaseConfig);
// export const db = firebase.initializeApp(firebaseConfig).firestore();
const db = firebase.firestore();
// const auth = firebase.auth();
// const currentUser = auth.auth();

// firebase collections
const repairsCollection = db.collection("repairs");

export { db, repairsCollection };
